import type { HelpFile } from '../../types/help'
import { AccountStatusHeaderTestIds } from '../../../testids/AccountStatusHeaderTestIds'

export const accountStatusHeaderHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [AccountStatusHeaderTestIds.accountStatusHeaderSummary]:
      'Kompaktzusammenfassung des jüngsten Kontostatus-Ereignisses — Statuspaar, auslösende Quelle, Akteur, Zeitstempel und gekürzte Begründung.',
    [AccountStatusHeaderTestIds.accountStatusHeaderFromStatus]:
      'Vorheriger Kontostatus vor diesem Übergang. Bei der initialen Erstellungszeile ausgeblendet.',
    [AccountStatusHeaderTestIds.accountStatusHeaderToStatus]:
      'Neuer Kontostatus nach diesem Übergang. Die Erstellungszeile zeigt "Erstellt als <Status>", da kein fromStatus existiert.',
    [AccountStatusHeaderTestIds.accountStatusHeaderTriggerSource]:
      'Welcher Geschäftsprozess die Änderung ausgelöst hat (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB usw.).',
    [AccountStatusHeaderTestIds.accountStatusHeaderActor]:
      'Der ausführende Benutzer. JML-Kaskade-Ereignisse zeigen "System (JML_LEAVER)", da die Änderung durch ein Leaver-Ereignis der übergeordneten Identität ausgelöst wurde.',
    [AccountStatusHeaderTestIds.accountStatusHeaderTimestamp]:
      'Relative Zeit des Übergangs. Per Hover wird der absolute Zeitstempel angezeigt.',
    [AccountStatusHeaderTestIds.accountStatusHeaderReason]:
      'Freitext-Begründung zum Zeitpunkt des Übergangs. Auf 80 Zeichen gekürzt; vollständiger Text per Hover.',
    [AccountStatusHeaderTestIds.accountStatusHeaderViewTimeline]:
      'Den vollständigen Reiter mit der Kontostatus-Zeitleiste öffnen, um alle Statusänderungen dieses Kontos zu sehen.',
  },
}
